import { validate } from 'vee-validate'
import { VerifyResult, State } from '@/types'
import { Store } from 'vuex'
import { computed } from 'vue'
import validateAuthorInfoView from './authorInfo'
import validateUploadFilesView from './uploadFiles'
import validateArticleInfoView from './articleInfo'
import validateReviewEditorialView from './reviewEditorial'

export default async function validateReviewStep(store: Store<State>) {
  const result = await validate(store.state.activeSubmission.termsAgreed, 'terms-and-conditions-required')

  const verifyResult: VerifyResult = {
    valid: result.errors.length === 0,
    errors: result.errors.length !== 0 ? [result.errors.toString()] : [],
    failedRules: result.errors.length !== 0 ? { 'terms-and-conditions-required': result.errors.toString() } : {},
    field: 'terms-and-conditions-required',
    rules: '',
  }

  store.commit('setVerifyResult', {
    key: 'finalReviewVerifyResult',
    verifyResult,
  })
}

export async function validateAllSteps(store: Store<State>) {
  const articleTitle = computed(() => store.state.activeSubmission.title)
  const articleAbstract = computed(() => store.state.activeSubmission.abstract)
  const articleCcdcNumbers = computed(() => store.state.activeSubmission.ccdcNumbers)

  await Promise.all([
    validateUploadFilesView(store),
    validateArticleInfoView(store, articleTitle, articleAbstract, articleCcdcNumbers),
    validateAuthorInfoView(store),
    validateReviewEditorialView(store),
    validateReviewStep(store),
  ])
}
